import { render, staticRenderFns } from "./ApplyRecord.vue?vue&type=template&id=2d7592e0&"
import script from "./ApplyRecord.vue?vue&type=script&lang=js&"
export * from "./ApplyRecord.vue?vue&type=script&lang=js&"
import style0 from "./ApplyRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports